<template>
    <transition name="fade">
        <div v-if="visible" class="popup-overlay">
            <div class="popup">
                <!-- 关闭按钮 -->
                <!-- <button class="close-btn" @click="closePopup">×</button> -->

                <!-- 主标题 -->
                <h2 class="popup-title">{{ title }}</h2>

                <!-- 二级标题 -->
                <h3 v-if="subtitle" class="popup-subtitle">{{ subtitle }}</h3>

                <!-- 弹窗内容 -->
                <p class="popup-content">{{ content }}</p>

                <!-- 操作按钮 -->
                <button class="popup-btn" @click="confirmAction">{{ $t("ISee") }}</button>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'AppPopup',
        props: {
            title: {
                type: String,
                default: '提示'
            },
            subtitle: {
                type: String,
                default: '' // 默认不显示
            },
            content: {
                type: String,
                default: '这里是弹窗内容'
            },
            buttonText: {
                type: String,
                default: '确定'
            },
            modelValue: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            visible: {
                get() {
                    return this.modelValue;
                },
                set(val) {
                    this.$emit('update:modelValue', val);
                }
            }
        },
        methods: {
            closePopup() {
                this.visible = false;
            },
            confirmAction() {
                this.$emit('confirm'); // 触发父组件的确认操作
                this.closePopup();
            }
        }
    };
</script>

<style scoped>
    /* 遮罩层 */
    .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    /* 弹窗 */
    .popup {
        background: linear-gradient(135deg, #fff7f0, #ffefe3);
        width: 380px;
        border-radius: 12px;
        text-align: center;
        padding: 28px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        position: relative;
        animation: popup-bounce 0.3s ease-out;
        margin-bottom: 380px;
        line-height: 34px;
    }

    /* 关闭按钮 */
    .close-btn {
        position: absolute;
        top: 12px;
        right: 12px;
        color: #b5b5b5;
        background: linear-gradient(135deg, #fff7f0, #ffefe3);
        width: 26px;
        height: 26px;
        border-radius: 50%;
        font-size: 16px;
        cursor: pointer;
        transition: transform 0.2s ease-in-out;
        border: none;
    }

    /* 主标题 */
    .popup-title {
        font-size: 22px;
        font-weight: bold;
        color: #ff3366;
        margin-bottom: 6px;
    }

    /* 二级标题 */
    .popup-subtitle {
        font-size: 16px;
        color: #ff8c42;
        font-weight: 500;
        margin-bottom: 12px;
    }

    /* 内容文本 */
    .popup-content {
        font-size: 15px;
        color: #444;
        margin-bottom: 18px;
    }

    /* 按钮 */
    .popup .popup-btn {
        background: #ff3366;
        color: white;
        border: none;
        padding: 12px 20px;
        font-size: 16px;
        border-radius: 8px;
        cursor: pointer;
        font-weight: bold;
        width: 100%;
    }

    /* 进出场动画 */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
